module.exports = __webpack_public_path__ + "img/icon-31-green.d5064dfd.svg";